import { ServiceOfferingsGrid } from '../components/ServiceOfferingsGrid'

export function Services() {
  return (
    <div className="pt-20">

      {/* Services Grid */}
      <ServiceOfferingsGrid />
    </div>
  )
}
